import React, { createContext, useContext } from 'react';
import { PropTypes } from 'prop-types';

const OverviewDataContext = createContext(null);

export const OverviewDataProvider = ({ value, children }) => (
  <OverviewDataContext.Provider value={value}>
    {children}
  </OverviewDataContext.Provider>
);

OverviewDataProvider.propTypes = {
  value: PropTypes.shape({
    sessionId: PropTypes.string,
    facilityId: PropTypes.string,
    overviewData: PropTypes.any,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool
  }).isRequired,
  children: PropTypes.node.isRequired
};

export const useOverviewDataContext = () => {
  const ctx = useContext(OverviewDataContext);
  if (!ctx) {
    throw new Error('useOverviewDataContext must be used within an OverviewDataProvider');
  }
  return ctx;
};
